import axios from 'axios'
import store from '@/store'
import {
  Indicator,
  MessageBox
} from 'mint-ui'

const API_URL = ''

if (process.env.NODE_ENV === 'production' && process.env.IS_WEB !== 1) {
  axios.defaults.baseURL = 'http://api.hsort.net'
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  Open()

  if (store.state.user.token) {
    config.headers['Authorization'] = 'Bearer ' + store.state.user.token
  }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  Close()

  if ([400001, 400002, 400003, 400004].some(t => t === response.data.code)) {
    store.commit('LOGOUT')
    throw new Error('400001')
  }

  return response.data
}, function (error) {
  Close()

  // Do something with response error
  return Promise.reject(error)
})

let count = 0

export function Open() {
  Indicator.open()
  count++
}

export function Close() {
  if (--count <= 0) {
    Indicator.close()
  }
}

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js